import { useState } from "react";
import { Button, Card, ErrorBanner, Field, Input } from "../components/ui.js";
import { useLogin } from "../hooks/useSession.js";

export function LoginPage() {
  const login = useLogin();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");

  return (
    <div className="flex min-h-dvh items-center justify-center px-3 py-6 sm:p-4">
      <Card className="w-full max-w-sm space-y-5">
        <div className="flex flex-col items-center gap-3 text-center">
          <img
            src="/logo-mark.svg"
            alt=""
            className="h-16 w-16 rounded-2xl bg-white p-1.5"
          />
          <img
            src="/logo-text.webp"
            alt="Farnsworth Collectibles"
            className="h-8 w-auto"
          />
          <p className="text-sm text-slate-400">Sign in to manage inventory.</p>
        </div>

        {login.isError ? (
          <ErrorBanner message={(login.error as Error).message} />
        ) : null}

        <form
          className="space-y-4"
          onSubmit={(event) => {
            event.preventDefault();
            login.mutate({ identifier, password });
          }}
        >
          <Field label="Email or username">
            <Input
              value={identifier}
              onChange={(event) => setIdentifier(event.target.value)}
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              required
            />
          </Field>
          <Field label="Password">
            <Input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>
          <Button type="submit" className="w-full" disabled={login.isPending}>
            {login.isPending ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <p className="mt-4 text-sm text-slate-400">For account or personal information deletion, contact the business through its <a href="https://fwcls.cc/privacy" className="underline">privacy request path</a>.</p>
      </Card>
    </div>
  );
}
